import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import { JobsAPI } from 'ducks/types/api-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

export const getJob = createAsyncThunk<JobsAPI, number>(`${Slices.JOB}/get`, async (entity_id, { rejectWithValue }) => {
  try {
    const res: AxiosResponse['data'] = await Andromeda.get(`/jobs/${entity_id}`);
    return res.data;
  } catch (error) {
    handleError(error);
    return rejectWithValue(error as AxiosError);
  }
});
